import { professionalEmails } from '@/config/emails'

export const companyProfile = {
  name: 'Nexline Global',
  legalName: 'Nexline Global Pvt. Ltd.',
  tagline: 'Web, SaaS, and AI product engineering for ambitious businesses.',
  description:
    'Nexline Global Pvt. Ltd. builds conversion-focused websites, SaaS platforms, backend systems, AI-powered web apps, mobile apps, and automation workflows for growing businesses.',
  url: 'https://nexline-global.vercel.app',
  locale: 'en',
  emails: professionalEmails,
  supportEmail: professionalEmails.support,
  socials: {
    x: 'https://x.com/nexlineglobal',
    github: 'https://github.com/nexline-global',
    linkedin: 'https://www.linkedin.com/company/nexline-global/about',
  },
  product: {
    name: 'Uprity',
    url: 'https://www.uprity.com',
    tagline: 'Reputation. AI Visibility. Growth.',
    caseStudySlug: 'uprity-product-track',
    caseStudyPath: '/case-studies/uprity-product-track',
    description:
      'Uprity is an AI-powered reputation management and AI visibility platform for SMBs, agencies, and multi-location brands.',
  },
  markets: ['SMBs', 'agencies', 'SaaS founders', 'service businesses', 'multi-location operators'],
} as const
